/* Model */
class SurveyModel extends App.Models.BaseModel {
    modelUrl = 'Survey';
}

App.Models.Survey = SurveyModel;

/* Collection */
class SurveyCollection extends App.Collections.BaseCollection {
    url = 'Survey';
    model = App.Models.Survey;
}

App.Collections.Surveys = SurveyCollection;

/* Router */
class SurveyRouter extends App.Routers.BaseRouter {
    constructor() {
        const entityName = 'Survey';
        const model = App.Models.Survey;
        const collectionClass = App.Collections.Surveys;

        super(entityName, model, collectionClass);

        if (!App.Forms.Survey) {
            var options = Monet.Grid.Utils.paginationOptions;

            App.Forms.Survey = {
                pagination: {
                    first: options.FIRST,
                    max: 200
                }
            };

        }
    }

    beforeList = () => {
        const addMenuToGrid = () => {
            var enabledMenus = Monet.Grid.Utils.getMenusEnabledFromGridLayout(App.Forms.Survey.layout.index);

            var optionsMenu = {
                targetEl: "#Survey #grid",
                description: 'description',
                addListenerToParent: false
            };

            var menu = new Greenmile.Survey.Grid.Menu();
            menu.setOptionsMenu(optionsMenu);
            menu.setEnabledMenus(enabledMenus);

            var grid = App.Forms.Survey.table;
            var removeMenu = function (context) {
                return function () {
                    if (context.gridMenu) {
                        context.gridMenu.removeAllMenus();
                    }
                };
            }(menu);

            var showMenu = function (context) {
                return function (e, args) {
                    context.showMenuToRowSelected(e, args);
                };
            }(menu);

            grid.onClick.unsubscribe(showMenu);
            grid.onClick.subscribe(showMenu);
            grid.onScroll.unsubscribe(removeMenu);
            grid.onScroll.subscribe(removeMenu);
        };

        var firstResult = App.Forms.Survey.pagination.first;
        var maxResults = 200;
        var jsonSort = '';

        if (App.Forms[this.entityName].columnToOrders) {
            var columns = App.Forms[this.entityName].columnToOrders;
            var columnsLength = App.Forms[this.entityName].columnToOrders.length;
            var ordersFormatted = [];

            for (var i = 0; i < columnsLength; i++) {
                ordersFormatted.push({
                    attr: columns[i].field,
                    type: columns[i].order
                });
            }
            jsonSort = '"orders":' + JSON.stringify(ordersFormatted) + ',';
        }

        var criteria = '{"filters":["*","organization.*", "surveySections.*", "surveyApplyRule.*", ' +
            '"surveySections.surveyQuestions.*", "userReleased.*", "releasedDate", "userClosed.*", "closedDate"],' +
            jsonSort +
            '"firstResult":' + firstResult + ',"maxResults":' + maxResults + '}';

        this.collectionCriteria = criteria;
        this.projection = criteria;

        addMenuToGrid();
    }

}

App.Routers.Survey = SurveyRouter;
